module.exports = __webpack_public_path__ + "static/media/reversecover-1.a4dccc64.pdf";